<style scoped>
.v-application .text-h4 {
  font-family: "Prompt", sans-serif !important;
  font-size: 24px !important;
}
.text-spacing {
  letter-spacing: 0px !important;
}
.v-application .white {
  border: #ccd0d9 solid 1px !important;
}
</style>

<template>
  <div>
    <v-layout class="d-flex justify-space-between">
      <div
        class="text-h4 font-weight-black primary--text text-spacing"
        color="blue"
      >
        รายชื่อลูกค้าที่โอนเงินแล้ว
      </div>
      <v-spacer></v-spacer>
    </v-layout>
    <v-divider class="my-2"></v-divider>

    <v-layout class="mb-2" justify-end>
      <v-btn
        color="white excel-border"
        elevation="0"
        class="mx-3"
        light
        @click="auto_contract()"
      >
        <v-icon left>mdi-file-sync-outline</v-icon>ทำสัญญาอัตโนมัติ
      </v-btn>
    </v-layout>
    <v-data-table
      :headers="headers"
      :items="getIndex"
      :items-per-page="15"
      item-key="index"
      v-model="selected"
      show-select
    >
      <template #item="{ item }">
        <tr>
          <td>
            <v-checkbox
              class="pa-0 ma-0"
              v-model="selected"
              :value="item"
              hide-details
            ></v-checkbox>
          </td>
          <td>
            <span>
              {{ item.index }}
            </span>
          </td>
          <td>
            <span style="font-weight: bold">{{ item.CUSTOMER_NAME }}</span>
            <p class="mb-n1 mt-1" style="font-size: 12px">{{ item.NOTE }}</p>
          </td>
          <td>{{ item.PROVIDER_PHONE }}</td>
          <td>{{ item.DATE_PAID | formatDate }}</td>
          <td>{{ item.TXN_AMOUNT | delimeter }}</td>
          <td>{{ item.CONTRACT_CATEGORY }}</td>
        </tr>
      </template>

      <template v-slot:no-data>
        <v-btn color="info" @click="initialize">
          <v-icon left>mdi-refresh</v-icon>รีเฟรชข้อมูล
        </v-btn>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import TableMenuCustomer from '../../components/TableMenuCustomer'
import CustomerStatus from '../../components/CustomerStatus'
import filterCustomer from '../../components/filterCustomer'
import moment from 'moment'
import { mapMutations, mapActions } from 'vuex'

export default {
  components: {
    TableMenuCustomer,
    CustomerStatus,
    filterCustomer
  },
  data() {
    return {
      isfromNew: false,
      search: "",
      singleSelect: false,
      selected: [],
      headers: [
        {
          text: "ลำดับ",
          align: "start",
          sortable: false,
          value: "index",
        },
        {
          text: "รายชื่อ",
          align: "start",
          sortable: false,
          value: "CUSTOMER_NAME",
        },
        { text: "เบอร์โทร", value: "PROVIDER_PHONE" },

        { text: "โอนเมื่อ", value: "DATE_PAID" },
        { text: "ยอดโอน", value: "TXN_AMOUNT" },
        { text: "ประเภท", value: "STATUS", sortable: false, width: '120' },
      ],
      desserts: [],

    };
  },
  filters: {
    delimeter(data) {
      let y = parseFloat(data).toFixed(2)
      let x = y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

      return x == 'NaN' ? 0 : x

    },
    formatDate(data) {
      console.log(data)
      return moment(data).format('DD/MM/YYYY HH:mm')
    }
  },
  computed: {
    // count index in table and chang date format
    getIndex() {
      return this.desserts.map((item, index) => ({
        ...item,
        index: index + 1,
        // create_date: moment(CREATE_DATE)
        //   .add(543, "years")
        //   .format("DD/MM/YYYY hh:mm:ss", true),
      }));
    },
    //   listNew() {
    //     this.listOldcustomer();
    //   }
  },
  created() {
    this.listOldcustomer();
    //this.list_c_period();
  },
  methods: {
    ...mapMutations({
      LOADER: "Drawer/SET_LOADER"
    }),
    initialize() {
      this.listOldcustomer();
    },
    insert_customer() {
      this.$router.push({ path: "/newCustomer/add-newCustomer" });
      this.$store.commit("CustomerDetail/SET_IS_EDIT", "Admin");
    },
    deleteItem(item) {
      const _this = this;
      this.$token_api
        .delete("/delete-Customer", {
          data: { CON_ID: item.CUSTOMER_ID },
        })
        .then((response) => {
          _this.listOldcustomer()
          this.$swal("ลบลูกค้า", "ลูกค้าเรียบร้อย", "question");
        })
        .catch((err) => { });

    },
    async auto_contract() {
      let data_cus = this.selected
      this.LOADER(true)
      if (data_cus.length > 0) {
        data_cus.map((x) => {
          x.ZONE_CODE = x.NEWCUSTOMER_ID + ' / ' + x.COLLECT_ZONE
        })
        await this.$token_api.post('automatic-contract', { DATA: data_cus }).catch((e) => { this.$swal("เกิดข้อผิดพลาด", "กรุณาลองใหม่อีกครั้ง", "error"); })
        this.LOADER(false)
        this.listOldcustomer()
      } else {
        this.LOADER(false)
        this.$swal({
          title: "กรุณาเลือกลูกค้า",
          text: "เลือกลูกค้าที่ต้องการทำสัญญา",
          icon: "warning",
          timer: 1500
        });
      }

    },
    listOldcustomer() {
      this.$token_api
        .post("/get-paid-customer", { STATUS: 'ดำเนินการ' })
        .then((response) => {
          this.desserts = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    clickReturn(val) {
      this.desserts = val
    }
  },
};
</script>